'use client'

import { useState } from 'react'
import { usePathname } from 'next/navigation'
import Header from './Header'
import Footer from './Footer'
import MobileBottomNav from './MobileBottomNav'
import { useVisitTracking } from '@/lib/commerce/hooks'
import { canShowCustomerChat, isAuthRoute } from '@/utils/util'
import CustomerChat from '../customer-chat/CustomerChat'
import RewardVariantModal from '../cart/RewardVariantModal'

export default function Layout({ children, vendor, categories, customer, subscription, campaigns }: { children: React.ReactNode, vendor: any, categories: any, customer: any, subscription?: any, campaigns?: any }) {
  useVisitTracking(vendor)
  const pathname = usePathname()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const fontClass = 'font-roboto'

  if (isAuthRoute(pathname)) {
    return (
      <div className={`${fontClass} min-h-screen text-white relative`} style={{ background: '#08080a' }}>
        <div className="fixed inset-0 -z-10" style={{ background: '#08080a' }} />
        {children}
      </div>
    )
  }

  return (
    <div className={`${fontClass} min-h-screen text-white relative`} style={{ background: '#08080a' }}>
      <div className="fixed inset-0 -z-10" style={{ background: '#08080a' }} />
      <Header vendor={vendor} categories={categories} subscription={subscription} campaigns={campaigns} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <main>{children}</main>
      <Footer vendor={vendor} subscription={subscription} />
      {canShowCustomerChat(vendor, subscription) && <CustomerChat vendor={vendor} />}
      <MobileBottomNav vendor={vendor} customer={customer} subscription={subscription} setMobileMenuOpen={setMobileMenuOpen} />
      <RewardVariantModal />
    </div>
  )
}
